import { AxiosResponse } from 'axios';
import { useAppMutation } from './useAppMutation';

interface EnrolStudentsInOwnPortalPayload {
  integrationCourseIds: string[];
  employeeIds: string[];
}

export type OwnPortalFailureReason = 'noEmail' | 'refused' | 'unreachable' | 'notAttempted';

export interface IOwnPortalEnrolPair {
  employeeId: string;
  integrationCourseId: string;
  studentName: string;
  courseTitle: string;
  /** Failed pairs only: a code the client translates (`manage.enrolStudentsPage.ownPortalFailureReasons.*`). */
  reason: OwnPortalFailureReason | null;
}

/** Per pair, what the organisation's own LearnUpon portal did. Not all or nothing. */
export interface IEnrolStudentsInOwnPortalResponse {
  enrolled: IOwnPortalEnrolPair[];
  /** Already had access. */
  skipped: IOwnPortalEnrolPair[];
  failed: IOwnPortalEnrolPair[];
}

/**
 * Enrols the selected students into courses of the organisation's own LearnUpon portal. Free: no
 * balance, no card. The server answers 200 even when some pairs failed.
 */
export const useEnrolStudentsInOwnPortal = () => {
  return useAppMutation<
    AxiosResponse<IEnrolStudentsInOwnPortalResponse>,
    unknown,
    EnrolStudentsInOwnPortalPayload
  >('post', '/TrainingManager/courses/enrol-own-portal');
};
